import { alpha, Box, Container, Stack, useTheme } from "@mui/material";
import CohortCarouselSection from "../../component/courseDetailSection/CohortCarouselSection";
import DescriptionSection from "../../component/courseDetailSection/DescriptionSection";
import FactsSection from "../../component/courseDetailSection/FactsSection";
import HeroSection from "../../component/courseDetailSection/HeroSection";
import SharingSection from "../../component/courseDetailSection/SharingSection";
import { useCourseDetailsPageData } from "../../hook/useCourseDetailsPageData";
import { softwareQualityAssuranceCourse } from "./const/course";
import pageMapData from "./const/pagemap.json";
import type { CoursePageMap } from "../../type/course";

export default function SoftwareQualityAssuranceTraining() {
  const theme = useTheme();
  const pageMap = buildSoftwareQualityAssurancePageMap(pageMapData as CoursePageMap);
  const data = useCourseDetailsPageData({ courseName: softwareQualityAssuranceCourse.title, pageMap });

  return (
    <Box
      sx={{
        minHeight: 1,
        bgcolor: "background.default",
        backgroundImage: `
          radial-gradient(ellipse 58% 22% at 22% 5%, ${alpha(theme.palette.info.main, 0.1)} 0%, ${alpha(theme.palette.info.main, 0)} 76%),
          radial-gradient(ellipse 50% 18% at 12% 47%, ${alpha(theme.palette.info.dark, 0.09)} 0%, ${alpha(theme.palette.info.dark, 0)} 74%),
          radial-gradient(ellipse 46% 18% at 82% 82%, ${alpha(theme.palette.info.main, 0.055)} 0%, ${alpha(theme.palette.info.main, 0)} 72%),
          radial-gradient(ellipse 56% 24% at 92% 93%, ${alpha(theme.palette.info.light, 0.16)} 0%, ${alpha(theme.palette.info.main, 0.06)} 42%, ${alpha(theme.palette.info.main, 0)} 76%),
          linear-gradient(180deg, ${alpha(theme.palette.primary.main, 0.72)} 0%, ${theme.palette.background.default} 18%, ${
          theme.palette.background.default
        } 74%, ${
          theme.palette.background.default
        } 100%)
        `,
        backgroundSize: "100% 100%, 100% 100%, 100% 100%, 100% 100%, 100% 100%",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Stack spacing={0}>
        <Container maxWidth="lg" sx={{ px: { xs: 3, md: 4 } }}>
          <HeroSection data={data} />
        </Container>

        <Container maxWidth="lg" sx={{ px: { xs: 3, md: 4 } }}>
          <DescriptionSection data={data} />
        </Container>

        <Container maxWidth="lg" sx={{ px: { xs: 3, md: 4 } }}>
          <CohortCarouselSection data={data} />
          {data.sharingItems.length === 0 ? null : <SharingSection data={data} />}
          <FactsSection data={data} />
        </Container>
      </Stack>
    </Box>
  );
}

function buildSoftwareQualityAssurancePageMap(rawPageMap: CoursePageMap): CoursePageMap {
  const imageUrls = softwareQualityAssuranceCourse.carouselImages.map((item) => item.src);
  const cohortItems = imageUrls.map((src, index) => ({
    id: `sqa-image-${index + 1}`,
    title: `Cohort ${index + 1} 學員紀錄`,
    description: "課堂與畢業相片紀錄。",
    coverImage: src,
  }));

  return {
    ...rawPageMap,
    sections: rawPageMap.sections.map((section) => {
      if (section.id !== "cohorts") return section;

      return {
        ...section,
        content: {
          ...(section.content as { cohorts?: unknown }),
          cohorts: cohortItems,
        },
      };
    }),
  };
}
